module.exports = __webpack_public_path__ + "static/img/jyfb.1cd7408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimg/jyfb.png
// module id = PMbJ
// module chunks = 4